import { useToast } from '@/view/components/ui/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { WithdrawService } from '../services/WithdrawService'

interface ManualWithdrawPayload {
  amount: number
  user: string
  status: 'UNPAID' | 'PENDING' | 'PAID'
}

export const useManualWithdraw = () => {
  const { toast } = useToast()
  const queryClient = useQueryClient()

  const {
    mutateAsync: manuallyWithdraw,
    isError,
    isSuccess,
    error,
  } = useMutation({
    mutationFn: (payload: ManualWithdrawPayload) =>
      WithdrawService.ManuallyWithdraw(payload),
    onSuccess(_, variables) {
      toast({
        title: 'Saque manual solicitado com sucesso.',
      })

      queryClient.invalidateQueries({ queryKey: ['withdraws'] })

      queryClient.invalidateQueries({
        queryKey: ['getAvailvableAmount', variables.user],
      })
    },
    onError(err: any) {
      toast({
        variant: 'destructive',
        title: 'Erro ao solicitar saque manual.',
        description: err?.message || 'Tente novamente mais tarde.',
      })
    },
  })

  return {
    manuallyWithdraw,
    isError,
    isSuccess,
    error,
  }
}
